// extracted by mini-css-extract-plugin
module.exports = {"filters":"ob_IrG8oa","content":"ob_mGFJSe","column":"ob_3xuENm","withFullWidth":"ob_7Yturb","section":"ob_Adorcp","trending":"ob_v41SLW","recommendations":"ob_pP7kLK"};